export const whatsOnTodayParams = [
  [`StartDate=${new Date().toISOString()}`],
  [`EndDate=${new Date().toISOString()}`],
  ['TileType=2'],
  ['PageNum=1'],
  ['ItemsPerPage=6'],
  ['PageType=3'],
  ['GenreId='],
].join('&');
